/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FullscreenDialog, Typography } from '@coursera/cds-core';

import PlanningTool from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/ToolRenderer';

import _t from 'i18n!nls/degree-home';

const { Header, Content } = FullscreenDialog;

type Props = {
  open: boolean;
  closeModal: () => void;
};

const styles = {
  header: css`
    align-items: center;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-300);
  `,
};

const PlanningToolDialog: React.VFC<Props> = ({ open, closeModal }) => {
  return (
    <FullscreenDialog open={open} onClose={closeModal}>
      <Header css={styles.header} slot1={<Typography variant="h2semibold"> {_t('Graduation plan')}</Typography>} />
      <Content css={styles.content}>
        <PlanningTool />
      </Content>
    </FullscreenDialog>
  );
};

export default PlanningToolDialog;
